module.exports = __webpack_public_path__ + "static/media/login-chr.5c5c4fcb.svg";